import type { MeetingBasedEventTypeId } from '@ps/isp-web-services-types';
import type { TranslationTag } from '@ps/web-core-intl';

import { EventTypeId } from '@swf/sports/types/eventType';
import { isMeetingBasedEventTypeId } from '@swf/sports/utils/isEventTypeId';

import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_Ante_Post_Greyhound_Racing_Bet_ELL,
  TXTWCL_Ante_Post_Horse_Racing_Betting_ELL,
  TXTWCL_Browse_future_greyhound_racing_ELL,
  TXTWCL_Browse_future_horse_racing_odd_ELL
} from './sportsAnimalRacingFuture.messages.json';

const titleMap: Record<MeetingBasedEventTypeId, TranslationTag> = {
  [EventTypeId.HORSE_RACING]: TXTWCL_Ante_Post_Horse_Racing_Betting_ELL,
  [EventTypeId.GREYHOUND_RACING]: TXTWCL_Ante_Post_Greyhound_Racing_Bet_ELL
};

const descriptionMap: Record<MeetingBasedEventTypeId, TranslationTag> = {
  [EventTypeId.HORSE_RACING]: TXTWCL_Browse_future_horse_racing_odd_ELL,
  [EventTypeId.GREYHOUND_RACING]: TXTWCL_Browse_future_greyhound_racing_ELL
};

const sportsAnimalRacingFutureWidgets = [
  {
    title: 'Sports Event Type Info Widget',
    _content_type_uid: SportsWidgetType.SportsEventTypeInfo
  },
  {
    title: 'Sports Ante Post Events Widget',
    _content_type_uid: SportsWidgetType.SportsAntePostEvents
  }
] satisfies readonly SectionWidgetConfig[];

export const sportsAnimalRacingFuture = ({ eventTypeId }: { eventTypeId: EventTypeId }) => {
  const titleTag = isMeetingBasedEventTypeId(eventTypeId)
    ? titleMap[eventTypeId]
    : TXTWCL_Ante_Post_Horse_Racing_Betting_ELL;

  const descriptionTag = isMeetingBasedEventTypeId(eventTypeId)
    ? descriptionMap[eventTypeId]
    : TXTWCL_Browse_future_horse_racing_odd_ELL;

  return buildSportsLayoutPageResponse({
    alias: 'sportsAnimalRacingFuture',
    seoConfig: {
      descriptionTag,
      titleTag
    },
    mainSectionWidgetConfigs: sportsAnimalRacingFutureWidgets
  });
};
